import React from "react";
import { Col, Pagination, PaginationProps, Row } from "antd";
import { CLIENT_SIDE_PAGE_SIZE_OPTIONS } from "../../hooks/useClientPagination";

interface ClientSidePaginationProps {
  currentPage: number;
  pageSize: number;
  total: number;
  onPaginationChange: (page: number, pageSize: number) => void;
  pageSizeOptions?: number[];
}

const itemRender: PaginationProps["itemRender"] = (
  _,
  type,
  originalElement
) => {
  if ((type === "prev" || type === "next") && React.isValidElement(originalElement)) {
    return React.cloneElement(
      originalElement,
      {},
      <span className="nav-buttons">{type === "prev" ? "Previous" : "Next"}</span>
    );
  }
  return originalElement;
};

const ClientSidePagination = ({
  currentPage,
  pageSize,
  total,
  onPaginationChange,
  pageSizeOptions,
}: ClientSidePaginationProps) => {
  const resolvedPageSizeOptions = pageSizeOptions?.length
    ? pageSizeOptions
    : [...CLIENT_SIDE_PAGE_SIZE_OPTIONS];
  const totalPages = Math.ceil(total / pageSize);
  const minimumPageSize = Math.min(...resolvedPageSizeOptions);
  const shouldShowPaginationControls =
    totalPages > 1 || total > minimumPageSize;

  if (!shouldShowPaginationControls) {
    return null;
  }

  return (
    <Row>
      <Col span={24} style={{ textAlign: "right" }} className="pagination-container">
        <Pagination
          className="unified-pagination"
          current={currentPage}
          total={total}
          pageSize={pageSize}
          showSizeChanger
          showTotal={(value, range) => `${range[0]}-${range[1]} of ${value}`}
          pageSizeOptions={resolvedPageSizeOptions.map((value) => String(value))}
          onChange={onPaginationChange}
          itemRender={itemRender}
        />
      </Col>
    </Row>
  );
};

export default ClientSidePagination;